import React from 'react';

const FeatureCard = ({ 
  svgSrc, 
  heading, 
  bodyText,
  className = '' 
}) => {
  // Relative positioning of text based on card proportions
  return (
    <div className={`relative flex-shrink-0 flex flex-col ${className}`}>
      {/* SVG Background Container */}
      <div className="relative w-full rounded-3xl overflow-hidden">
        <img src={svgSrc} alt="" className="w-full h-auto" aria-hidden="true" />
        
        {/* Overlay Text Container for SEO */}
        <div className="absolute inset-0 flex flex-col p-[3.5%]"> {/* 32px/918px ≈ 3.5% */}
          {/* Top space for graph already in SVG */}
          <div className="h-[60%]"></div> {/* Increased from 34% to 38% to position heading lower */}
          
          {/* Heading Text - positioned below the graph */}
          <h3 
            className="font-dm-sans font-medium text-[5.2vw] sm:text-[3.2vw] md:text-[2.6vw] lg:text-[2.2vw] xl:text-[1.8vw] 2xl:text-[1.6vw] leading-[100%] mb-[2.6%] max-w-[40%]"
            style={{ color: '#143E39' }}
          >
            {heading}
          </h3>
          
          {/* Body Text */}
          <p 
            className="font-dm-sans font-normal text-[2.6vw] sm:text-[1.8vw] md:text-[1.4vw] lg:text-[1.2vw] xl:text-[1vw] 2xl:text-[0.85vw] leading-[120%] max-w-[85%]"
            style={{ color: '#143E39' }}
          >
            {bodyText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeatureCard;